<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header">
        <h3>Referral Routing</h3>
    </div>
    <div class="panel-flat-body position-relative" style="min-height: initial" [formGroup]="form()">
        <div class="referral-field-grid">
            <label class="referral-field-label" for="coCounselFirmId">Co-Counsel Firm</label>
            @if (coCounselFirmOptions()?.length) {
                <referral-input-with-revert
                    formControlName="coCounselFirmId"
                    [systemValue]="systemReferral()?.coCounselFirmId"
                    [originalValue]="originalReferral()?.coCounselFirmId"
                    [selectOptions]="coCounselFirmOptions()"
                    [isNumber]="true"
                />
            }
        </div>
    </div>
</div>
